import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { SuggestedFaqState, SLICE_NAME } from './models';

const suggestedFaqSelector = (state: RootState): SuggestedFaqState => state[SLICE_NAME];

export const selectSuggestedFaqs = createSelector(
  suggestedFaqSelector,
  (state: SuggestedFaqState) => state.suggestions,
);

export const selectSuggestedFaqsIsLoading = createSelector(
  suggestedFaqSelector,
  (state: SuggestedFaqState) => state.isLoading,
);

export const selectSuggestedFaqsError = createSelector(suggestedFaqSelector, (state: SuggestedFaqState) => state.error);

export const selectSuggestedFaqsPagination = createSelector(
  suggestedFaqSelector,
  (state: SuggestedFaqState) => state.pagination,
);
